import type { StepListProps } from '../campaign/components/steps/StepList';
import { SelectEquipment, SelectISP, SelectPremiums, Summary, VerificationAndContactInfo } from './steps/Steps';

export const v2Routes = {
  index: '/',
  campaign: ':campaignUrl',
  absoluteStepPathBase: '/:campaignUrl',
  // relative step paths
  campaignPremiums: '',
  campaignEquipment: 'utstyr',
  campaignInternet: 'internett',
  campaignContactInfo: 'kontaktinfo',
  campaignSummary: 'oppsummering',
} as const;

type V2Route = StepListProps[number] & { element: React.ReactNode; type: StepType; wideLayout: boolean };
export type StepType = 'premium' | 'equipment' | 'internet' | 'contactInfo' | 'summary';
export const v2Steps: V2Route[] = [
  { stepPath: v2Routes.campaignPremiums, title: 'Innhold', element: <SelectPremiums />, type: 'premium', wideLayout: true },
  { stepPath: v2Routes.campaignEquipment, title: 'Utstyr', element: <SelectEquipment />, type: 'equipment', wideLayout: true },
  { stepPath: v2Routes.campaignInternet, title: 'Internett', element: <SelectISP />, type: 'internet', wideLayout: false },
  {
    stepPath: v2Routes.campaignContactInfo,
    title: 'Din info',
    element: <VerificationAndContactInfo />,
    type: 'contactInfo',
    wideLayout: false,
  },
  { stepPath: v2Routes.campaignSummary, title: 'Oversikt', element: <Summary />, type: 'summary', wideLayout: true },
];
